import { PrinterMachineColumn, PrinterShift } from '../../../types/api/user'

export const PRINTER_MACHINE_COLUMNS: PrinterMachineColumn[] = [
    'Omet 1',
    'MPS 1',
    'MPS 2',
    'MPS 3',
    'Bobst 1',
    'Bobst 2',
    'Bobst 3',
    'Термо 1',
    'DCMQ 1',
    'Durst 1',
    'WG 1',
    'GF 1',
    'GF 2',
    'RG 1',
    'DMS 1',
]

export const PRINTER_SHIFTS: PrinterShift[] = ['1', '2', '3', '4']

export const SHIFT_LABELS: Record<PrinterShift, string> = {
    '1': 'I смена',
    '2': 'II смена',
    '3': 'III смена',
    '4': 'IV смена',
}

export const SHIFT_HEADER_COLORS: Record<PrinterShift, string> = {
    '1': '#13c2c2',
    '2': '#722ed1',
    '3': '#52c41a',
    '4': '#1677ff',
}
